export default __webpack_public_path__ + "static/media/NoResultSearch.54eec65a.svg";